import * as React from 'react';

import {
    getIconNameForAdvType,
    getTitleForAdvType
} from '../../service/BannerHelpers/BannerHelpers';
import { Bem } from '../../service/Bem/Bem';
import { AdvType, AdvTypeClient, CampaignType } from '../../typings/domain';
import { Shape2, Shape2Theme } from '../Shape2/Shape2';

type GridBannerTypeCellProps = {
    type: AdvType | AdvTypeClient;
    campaignType: CampaignType;
};

export class GridBannerTypeCell extends React.PureComponent<
    GridBannerTypeCellProps,
    {}
> {
    render() {
        const { type, campaignType } = this.props;

        return (
            <Shape2
                cls={Bem.cls('grid-type-cell', 'icon')}
                theme={Shape2Theme.light}
                icon={getIconNameForAdvType(type, campaignType)}
                width={16}
                height={16}
                title={getTitleForAdvType(type, campaignType)}
            />
        );
    }
}
